import _ from 'lodash';

/**
 * Formats an app category enum into a human-readable label.
 * 'NEWS_AND_MAGAZINES' => 'News & Magazines'
 *
 * @param {string} category
 * @returns {string} Formatted category label
 */
export const formatCategory = (category: string): string => _.startCase(_.toLower(category)).replace(/\bAnd\b/g, '&');
